import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button,
  Row,
  Col,
  Label,
  Input,
  Form,
  Badge,
} from "reactstrap";
import Swal from "sweetalert2";
import axios from "axios";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import CurrencyInput from "react-currency-input-field";

function PagosProveedoresCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;
  const URL_EMBARQUES = process.env.REACT_APP_URL_EMBARQUES;
  const URL_CONCEPTOS_PAGO = process.env.REACT_APP_URL_CONCEPTOS_PAGO;
  const URL_PAGOS_PROVEEDORES = process.env.REACT_APP_URL_PAGOS_PROVEEDORES;
  const URL_ARTICULOS_EMBARQUES = process.env.REACT_APP_URL_ARTICULOS_EMBARQUES;
  const URL_ANTICIPOS_PROVEEDORES = process.env.REACT_APP_URL_ANTICIPOS_PROVEEDORES;
  const URL_MOVIMIENTOS_BANCOS = process.env.REACT_APP_URL_MOVIMIENTOS_BANCOS;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;

  let hoy = moment(new Date()).format("YYYY-MM-DD");

  const [fecha, setFecha] = useState(hoy);
  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [ordenesCompra, setOrdenesCompra] = useState([]);
  const [selectedOC, setSelectedOC] = useState("");
  const [embarques, setEmbarques] = useState([]);
  const [selectedEmbarque, setSelectedEmbarque] = useState("");
  const [conceptos, setConceptos] = useState([]);
  const [bancos, setBancos] = useState([]);
  const [selectedBanco, setSelectedBanco] = useState("");
  const [formaPago, setFormaPago] = useState("Transfer");
  // Estado del pago: "Simulado" (no afecta saldos) | "Pagado" (afecta saldos)
  const [estadoPago, setEstadoPago] = useState("Simulado");
  const [validaBoton, setValidaBoton] = useState(true);
  // Comisión B2B (pago extra = % del monto en pesos, contra proveedor "COMISION B2B")
  const [generaB2B, setGeneraB2B] = useState(false);
  const [comisionB2B, setComisionB2B] = useState(3.33);
  // Saldo de la NotaCxP de mercancía del embarque (tope para LIQUIDACION)
  const [saldoNotaCxP, setSaldoNotaCxP] = useState(0);

  // TC controlado: arranca en 18 y se sustituye por el real al capturar
  const TC_CONTROLADO = 18;
  const [inputFields, setInputFields] = useState([
    { id: uuidv4(), conceptosPago: "", montoUSD: 0, tipoCambio: TC_CONTROLADO, observaciones: "NA" },
  ]);

  // Catalogos base
  useEffect(() => {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    axios
      .get(URL_PROVEEDORES, { headers })
      .then((res) => setProveedores(res.data || []))
      .catch((err) => console.log(err));
    axios
      .get(URL_CONCEPTOS_PAGO, { headers })
      .then((res) =>
        setConceptos((res.data || []).filter((c) => c.is_active === "Si"))
      )
      .catch((err) => console.log(err));
    axios
      .get(URL_BANCOS, { headers })
      .then((res) => setBancos(res.data || []))
      .catch((err) => console.log(err));
  }, []);

  // Al elegir proveedor: cargar sus OCs y embarques activos
  // Al elegir proveedor: cargar sus OCs (los embarques dependen de la OC)
  useEffect(() => {
    if (!selectedProveedor) {
      setOrdenesCompra([]);
      setEmbarques([]);
      setSelectedOC("");
      setSelectedEmbarque("");
      return;
    }
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    setSelectedOC("");
    setSelectedEmbarque("");
    axios
      .get(URL_ORDENES_COMPRA, { headers })
      .then((res) => {
        const ocs = (res.data || []).filter(
          (o) =>
            o.proveedores?.[0]?._id === selectedProveedor &&
            o.is_active === "Si"
        );
        setOrdenesCompra(ocs);
      })
      .catch((err) => console.log(err));
  }, [selectedProveedor]);

  // Embarques: solo los que incluyen articulos de la OC seleccionada.
  // Si no hay OC, se muestran los del proveedor como respaldo.
  useEffect(() => {
    if (!selectedProveedor) return;
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };
    setSelectedEmbarque("");
    if (selectedOC) {
      axios
        .get(`${URL_ARTICULOS_EMBARQUES}PorOC/${selectedOC}`, { headers })
        .then((res) => {
          const embs = (res.data || []).filter((e) => e && e.is_active === "Si");
          setEmbarques(embs);
        })
        .catch((err) => console.log(err));
    } else {
      axios
        .get(URL_EMBARQUES, { headers })
        .then((res) => {
          const embs = (res.data || []).filter(
            (e) =>
              e.proveedores?.[0]?._id === selectedProveedor &&
              e.is_active === "Si"
          );
          setEmbarques(embs);
        })
        .catch((err) => console.log(err));
    }
  }, [selectedProveedor, selectedOC]);

  // Saldo de la NotaCxP de mercancía del embarque seleccionado (tope para LIQUIDACION)
  useEffect(() => {
    if (!selectedProveedor || !selectedEmbarque) {
      setSaldoNotaCxP(0);
      return;
    }
    axios
      .get(`${URL_NOTAS_CXP}Proveedor/${selectedProveedor}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        const nota = (res.data || []).find(
          (n) =>
            n.is_active === "Si" &&
            (n.tipo || "Mercancia") !== "Gasto" &&
            Array.isArray(n.embarques) &&
            n.embarques.some((e) => String(e?._id) === String(selectedEmbarque))
        );
        setSaldoNotaCxP(nota ? Number(nota.saldo) || 0 : 0);
      })
      .catch(() => setSaldoNotaCxP(0));
  }, [selectedProveedor, selectedEmbarque]);

  const handleChangeInput = (id, name, value) => {
    setInputFields((prev) =>
      prev.map((i) => (i.id === id ? { ...i, [name]: value } : i))
    );
  };

  const handleAddFields = () => {
    setInputFields((prev) => {
      // El nuevo renglón hereda el TDC del último (para no recapturarlo)
      const ultimoTC = prev.length ? prev[prev.length - 1].tipoCambio : TC_CONTROLADO;
      return [
        ...prev,
        {
          id: uuidv4(),
          conceptosPago: "",
          montoUSD: 0,
          tipoCambio: ultimoTC || TC_CONTROLADO,
          observaciones: "NA",
        },
      ];
    });
  };

  const handleRemoveFields = (id) => {
    setInputFields((prev) =>
      prev.length > 1 ? prev.filter((i) => i.id !== id) : prev
    );
  };

  const totalUSD = inputFields.reduce(
    (a, r) => a + (Number(r.montoUSD) || 0),
    0
  );
  // Total MXN = suma de (monto × TDC) por renglón (cada uno con su propio TDC)
  const totalMXN = inputFields.reduce(
    (a, r) => a + (Number(r.montoUSD) || 0) * (Number(r.tipoCambio) || 1),
    0
  );

  // ¿El concepto de un renglón es ANTICIPO?
  const esConceptoAnticipo = (idConcepto) => {
    const c = conceptos.find((x) => x._id === idConcepto);
    return c && String(c.concepto).trim().toUpperCase() === "ANTICIPO";
  };
  const esConceptoLiquidacion = (idConcepto) => {
    const c = conceptos.find((x) => x._id === idConcepto);
    return c && String(c.concepto).trim().toUpperCase() === "LIQUIDACION";
  };

  const savePagos = (event) => {
    event.preventDefault();
    if (!selectedProveedor) {
      Swal.fire({ icon: "error", title: "Falta el proveedor" });
      return;
    }
    const filas = inputFields.filter(
      (a) => a.conceptosPago !== "" && Number(a.montoUSD) !== 0
    );
    if (filas.length === 0) {
      Swal.fire({
        icon: "info",
        title: "Sin pagos",
        text: "Captura al menos un renglón con concepto y monto.",
      });
      return;
    }

    // LIQUIDACION no puede exceder el saldo de la NotaCxP del embarque
    if (selectedEmbarque) {
      const totalLiq = filas
        .filter((a) => esConceptoLiquidacion(a.conceptosPago))
        .reduce((s, a) => s + (Number(a.montoUSD) || 0), 0);
      if (totalLiq > (Number(saldoNotaCxP) || 0) + 0.001) {
        Swal.fire({
          icon: "error",
          title: "La liquidación excede el saldo",
          text: `La liquidación (${new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }).format(totalLiq)}) no puede pasar del saldo de la NotaCxP del embarque (${new Intl.NumberFormat(
            "en-US",
            { style: "currency", currency: "USD" }
          ).format(Number(saldoNotaCxP) || 0)}).`,
        });
        return;
      }
    }

    const anticipoRows = filas.filter((a) => esConceptoAnticipo(a.conceptosPago));
    const pagoRows = filas.filter((a) => !esConceptoAnticipo(a.conceptosPago));

    // Los ANTICIPOS crean un AnticiposProveedores real (egreso banco + recalc OC), asi que necesitan banco
    if (anticipoRows.length > 0 && !selectedBanco) {
      Swal.fire({
        icon: "error",
        title: "Falta el banco",
        text: "Los renglones con concepto ANTICIPO requieren seleccionar un banco.",
      });
      return;
    }

    setValidaBoton(false);
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    // 1) Pagos normales -> PagosProveedores (ledger). TDC por renglón.
    const pagosReq = pagoRows.map((a) => {
      const monto = Number(a.montoUSD) || 0;
      const tcRow = Number(a.tipoCambio) || 1;
      return axios.post(
        URL_PAGOS_PROVEEDORES,
        {
          fecha,
          proveedores: selectedProveedor,
          ordenesCompra: selectedOC || null,
          embarques: selectedEmbarque || null,
          conceptosPago: a.conceptosPago || null,
          montoUSD: monto,
          tipoCambio: tcRow,
          totalMXN: monto * tcRow,
          bancos: selectedBanco || null,
          observaciones: a.observaciones || "NA",
          validado: "No",
          estado: estadoPago,
        },
        { headers }
      );
    });

    // 2) ANTICIPOS -> AnticiposProveedores + egreso bancario (igual que AnticiposProveedoresCreate)
    const anticiposReq = anticipoRows.map((a) => {
      const importe = Number(a.montoUSD) || 0;
      const tcRow = Number(a.tipoCambio) || 1;
      return axios
        .post(
          URL_ANTICIPOS_PROVEEDORES,
          {
            fecha,
            importe,
            formaPago,
            observaciones: a.observaciones || "NA",
            bancos: selectedBanco,
            proveedores: selectedProveedor,
            ordenesCompra: selectedOC || null,
            embarques: selectedEmbarque || null,
            tipoCambio: tcRow,
            montoPesos: importe * tcRow,
            utilizado: 0,
            saldo: importe,
          },
          { headers }
        )
        .then((data) =>
          axios.post(
            URL_MOVIMIENTOS_BANCOS,
            {
              fecha,
              importe: -importe,
              tipo: "Egreso",
              bancos: selectedBanco,
              anticiposProveedores: data.data._id,
              moneda: "USD",
              tipoCambio: tcRow,
            },
            { headers }
          )
        );
    });

    // 3) Comisión B2B: por cada renglón (pago o anticipo), un pago extra en pesos
    //    contra el proveedor "COMISION B2B" = comision% × (monto × TC).
    const b2bReq = [];
    if (generaB2B) {
      const b2bProv = proveedores.find(
        (p) => p.nombre_comercial === "COMISION B2B"
      );
      const pct = Number(comisionB2B) || 0;
      if (b2bProv && pct > 0) {
        const todos = [
          ...pagoRows.map((a) => ({
            row: a,
            nombre:
              conceptos.find((c) => c._id === a.conceptosPago)?.concepto ||
              "PAGO",
          })),
          ...anticipoRows.map((a) => ({ row: a, nombre: "ANTICIPO" })),
        ];
        todos.forEach(({ row, nombre }) => {
          const monto = Number(row.montoUSD) || 0;
          const tcRow = Number(row.tipoCambio) || 1;
          const comisionPesos =
            Math.round(monto * tcRow * (pct / 100) * 100) / 100;
          if (comisionPesos === 0) return;
          b2bReq.push(
            axios.post(
              URL_PAGOS_PROVEEDORES,
              {
                fecha,
                proveedores: b2bProv._id,
                ordenesCompra: selectedOC || null,
                embarques: selectedEmbarque || null,
                conceptosPago: null,
                montoUSD: comisionPesos, // en pesos (afecta saldo del proveedor B2B)
                tipoCambio: 1,
                totalMXN: comisionPesos,
                observaciones: `Comisión B2B ${pct}% de ${nombre}`,
                esB2B: "Si",
                conceptoNombre: `B2B ${nombre}`,
                validado: "No",
                estado: estadoPago,
              },
              { headers }
            )
          );
        });
      }
    }

    Promise.all([...pagosReq, ...anticiposReq, ...b2bReq])
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Pago Proveedor",
            detalle: `Fecha ${fecha} / ${pagoRows.length} pago(s) / ${anticipoRows.length} anticipo(s)`,
            user: user.id,
          },
          { headers }
        );
        // Si hubo anticipos y hay un embarque seleccionado, se aplican solos a ese embarque
        const cierre = () => {
          Swal.fire("Good job!", "Registrado con éxito", "success");
          setTimeout(() => window.location.reload(), 1000);
        };
        if (anticipoRows.length > 0 && selectedEmbarque) {
          axios
            .get(`${URL_EMBARQUES}AplicarAnticipos/${selectedEmbarque}`, { headers })
            .then(cierre)
            .catch(() => cierre());
        } else {
          cierre();
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error?.response?.data || ""}`,
        });
        console.log(error);
        setValidaBoton(true);
      });
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.pagoProveedores ? (
        <div className="card container col-11">
          <h3 align="center">Captura de Pagos a Proveedor</h3>
          <Form onSubmit={savePagos}>
            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Fecha</Label>
                <Input
                  type="date"
                  value={fecha}
                  required
                  onChange={(e) => setFecha(e.target.value)}
                />
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Proveedor</Label>
                <Input
                  type="select"
                  value={selectedProveedor}
                  required
                  onChange={(e) => setSelectedProveedor(e.target.value)}
                >
                  <option value="">Selecciona</option>
                  {proveedores
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((p) => (
                      <option value={p._id}>
                        {p.codigo} - {p.nombre_comercial}
                      </option>
                    ))}
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">ODC (Orden de Compra)</Label>
                <Input
                  type="select"
                  value={selectedOC}
                  disabled={!selectedProveedor}
                  onChange={(e) => setSelectedOC(e.target.value)}
                >
                  <option value="">Sin OC</option>
                  {ordenesCompra
                    .sort((a, b) =>
                      a.idOrdenCompra < b.idOrdenCompra ? 1 : -1
                    )
                    .map((o) => (
                      <option value={o._id}>OC {o.idOrdenCompra}</option>
                    ))}
                </Input>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Embarque</Label>
                <Input
                  type="select"
                  value={selectedEmbarque}
                  disabled={!selectedProveedor}
                  onChange={(e) => setSelectedEmbarque(e.target.value)}
                >
                  <option value="">Sin Embarque</option>
                  {embarques
                    .sort((a, b) => (a.idEmbarques < b.idEmbarques ? 1 : -1))
                    .map((em) => (
                      <option value={em._id}>
                        EMB #{em.idEmbarques} {em.contenedor}
                      </option>
                    ))}
                </Input>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md={3}>
                <Label className="mr-sm-2">
                  Banco <small className="text-muted">(para ANTICIPO)</small>
                </Label>
                <Input
                  type="select"
                  value={selectedBanco}
                  onChange={(e) => setSelectedBanco(e.target.value)}
                >
                  <option value="">Selecciona un Banco</option>
                  {bancos
                    .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                    .map((b) => (
                      <option value={b._id}>
                        {b.banco} {b.cuenta}
                      </option>
                    ))}
                </Input>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">
                  Forma de Pago <small className="text-muted">(anticipo)</small>
                </Label>
                <Input
                  type="select"
                  value={formaPago}
                  onChange={(e) => setFormaPago(e.target.value)}
                >
                  <option value="Transfer">Transfer</option>
                  <option value="Efectivo">Efectivo</option>
                  <option value="TDC">TDC</option>
                </Input>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Estado</Label>
                <Input
                  type="select"
                  value={estadoPago}
                  onChange={(e) => setEstadoPago(e.target.value)}
                >
                  <option value="Simulado">Simulado</option>
                  <option value="Pagado">Pagado</option>
                </Input>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2 d-block">Comisión B2B</Label>
                <div className="d-flex align-items-center">
                  <Input
                    type="checkbox"
                    checked={generaB2B}
                    onChange={(e) => setGeneraB2B(e.target.checked)}
                    style={{ position: "static", marginRight: 8 }}
                  />
                  <Input
                    type="number"
                    step="any"
                    min="0"
                    value={comisionB2B}
                    disabled={!generaB2B}
                    onChange={(e) => setComisionB2B(e.target.value)}
                    style={{ width: 90 }}
                  />
                  <span className="ml-1">%</span>
                </div>
              </Col>
            </Row>

            <hr />

            <Row className="align-items-end">
              <Col md={3}>
                <Label className="mr-sm-2">Concepto de Pago</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Monto USD</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">TDC</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Total MXN</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Observaciones</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <Row key={inputField.id} className="mb-1">
                <Col md={3}>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={inputField.conceptosPago}
                    onChange={(e) =>
                      handleChangeInput(
                        inputField.id,
                        "conceptosPago",
                        e.target.value
                      )
                    }
                  >
                    <option value="">Selecciona</option>
                    {conceptos
                      .sort((a, b) => (a.concepto > b.concepto ? 1 : -1))
                      .map((c) => (
                        <option value={c._id}>{c.concepto}</option>
                      ))}
                  </Input>
                </Col>
                <Col md={2}>
                  <CurrencyInput
                    intlConfig={{ locale: "en-US", currency: "USD" }}
                    prefix="$"
                    defaultValue={0}
                    decimalsLimit={2}
                    allowNegativeValue={true}
                    value={inputField.montoUSD}
                    className="form-control form-control-sm"
                    onValueChange={(value) =>
                      handleChangeInput(inputField.id, "montoUSD", value || 0)
                    }
                  />
                </Col>
                <Col md={2}>
                  <Input
                    bsSize="sm"
                    type="number"
                    min="0"
                    step="any"
                    value={inputField.tipoCambio}
                    onChange={(e) =>
                      handleChangeInput(
                        inputField.id,
                        "tipoCambio",
                        e.target.value
                      )
                    }
                  />
                </Col>
                <Col md={2}>
                  <Input
                    bsSize="sm"
                    type="text"
                    disabled
                    value={new Intl.NumberFormat("es-MX", {
                      style: "currency",
                      currency: "MXN",
                    }).format(
                      (Number(inputField.montoUSD) || 0) *
                        (Number(inputField.tipoCambio) || 1)
                    )}
                  />
                </Col>
                <Col md={2}>
                  <Input
                    bsSize="sm"
                    type="text"
                    value={inputField.observaciones}
                    onChange={(e) =>
                      handleChangeInput(
                        inputField.id,
                        "observaciones",
                        e.target.value
                      )
                    }
                  />
                </Col>
                <Col md={1}>
                  <Button
                    size="sm"
                    color="danger"
                    onClick={() => handleRemoveFields(inputField.id)}
                    tabIndex="-1"
                  >
                    <i class="fas fa-minus"></i>
                  </Button>{" "}
                  <Button
                    size="sm"
                    color="info"
                    onClick={handleAddFields}
                    tabIndex="-1"
                  >
                    <i class="fas fa-plus"></i>
                  </Button>
                </Col>
              </Row>
            ))}

            <Row className="mt-3">
              <Col md={9} className="text-right">
                <h5>
                  Total USD{"  "}
                  <Badge color="danger" pill>
                    {new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                    }).format(totalUSD)}
                  </Badge>
                  {"    "}
                  Total MXN{"  "}
                  <Badge color="dark" pill>
                    {new Intl.NumberFormat("es-MX", {
                      style: "currency",
                      currency: "MXN",
                    }).format(totalMXN)}
                  </Badge>
                </h5>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col>
                {validaBoton ? (
                  <Button type="submit" className="btn btn-success">
                    Registrar
                  </Button>
                ) : (
                  <Button type="submit" className="btn btn-success" disabled>
                    Registrar
                  </Button>
                )}{" "}
                <Button
                  className="btn btn-danger"
                  href="/ListadoPagosProveedores"
                >
                  Regresar
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      ) : undefined}
    </>
  );
}

export default PagosProveedoresCreate;
